import { inject, Injectable } from "@angular/core";

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { IShortcutItem, IUserSettings, SuperSearchPersonParams, SuperSearchPersonResponse } from "../entities/shortcuts.model";
import { APP_CONFIG } from '@application/config';
import { AuthStore } from "@account/data-access";
import { IUiClientSettings } from "../entities/ui-client-settings.model";

@Injectable({providedIn: 'root'})
export class ShortcutsService {
    private readonly http = inject(HttpClient);
    private readonly appConfig = inject(APP_CONFIG);
    private readonly apiUrl = this.appConfig.apiUrl;
    private readonly authStore = inject(AuthStore);
  
  public getShortcuts(): Observable<IUserSettings> {
    return this.http.get<IUserSettings>(
      this.apiUrl.account_service + '/UserSettings/GetByPersonAsync',
      { 
        withCredentials: true
       }
    )
  }

  public createShortcuts(
      persons: IShortcutItem []
    ): Observable<IShortcutItem []> {
      return this.http.post<IShortcutItem []>(
        this.apiUrl.account_service + '/Sidebar',
        persons,
        { withCredentials: true }
      );
    }
  
  public updateUserSettings(userSettings: Partial<IUserSettings>): Observable<IUserSettings> {
    if (userSettings?.['Language']) {
        delete userSettings['Language'];
    }

    return this.http.patch<IUserSettings>(
      this.apiUrl.account_service + '/UserSettings', userSettings,
      { withCredentials: true }
    );
  }

  public updateUiClientSettingsAsync(userSettingsId: string, clientSettings: Partial<IUiClientSettings>): Observable<IUserSettings> {
    return this.http.put<IUserSettings>(
      this.apiUrl.account_service + '/UserSettings/UpdateUiClientSettingsAsync', clientSettings,
      {
        params: {
          userSettingsId
        },
        withCredentials: true
      }
    );
  }

  public getSuperSearchPerson(params: SuperSearchPersonParams): Observable<SuperSearchPersonResponse> {
    const headers = new HttpHeaders({
      'loadingBarIgnored': 'true'
    });

    return this.http.get<SuperSearchPersonResponse>(`${this.apiUrl.search_service}/api/search/persons`, 
      { 
        params: {
          ...params
        }, 
        withCredentials: true,
        headers
      }
    );
  }

}